module.exports = __webpack_public_path__ + "img/messages.6de63408.svg";